import { token } from '@atlaskit/tokens';

interface AppLogoProps {
  logoUrl: string;
}

const AppLogo: React.FC<AppLogoProps> = ({ logoUrl }) => (
  <img
    src={logoUrl}
    style={{ borderRadius: '4px', width: `${token('space.600', '48px')}` }}
  />
);

export default AppLogo;
